<div class="land">
  <div class="navigation">
    <div class="container">
    <div class="row justify-content-center">
      <div class="col col-md-4">
        <!-- <span class="logo"></span> -->
        <a routerLink="/">
          <img class="buk-logo" src="/assets/logo-a.png" alt="">
        </a>
      </div>

      <div class="col col-md-4 text-right">
        <ul class="navlinks hidden-mobile">
          <li>
            <button routerLink="/signup" class="btn btn-md btn-primary">{{ 'GENERAL.signupCta' | translate }}</button>
          </li>
        </ul>
        <ul class="navlinks visible-mobile">
          <!-- <li>
                  <a routerLink="/login">Login</a>
                </li> -->
          <li>
            <button routerLink="/signup" class="btn btn-md btn-primary">{{ 'GENERAL.signupCta' | translate }}</button>
          </li>
        </ul>
      </div>

    </div>
    </div>
  </div>

  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="text-center mb-4">
            <h2 class="title">{{ 'LANDING.landing.cookies' | translate }}</h2>
          </div>

          <div>
            <div #ngxCookiebot></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
